import React from 'react'
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import {BrowserRouter} from "react-router-dom";
import RegistrationApp from './src/RegistrationApp.js'
import configureStore from "./src/store/configureStore";
import {APP_NAME} from "./src/constants";

const store = configureStore();
const container = document.getElementById('project');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <BrowserRouter basename={APP_NAME}>
            <RegistrationApp />
        </BrowserRouter>
    </Provider>
);
